import React, { useEffect, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import CustomTable from "../../components/table/Table";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { clearMessage } from "../../redux/Slice/message";
import { useDispatch, useSelector } from "react-redux";
import { getQuote, getQuoteByServiceId, updateQuote } from "../../redux/Slice/quoteSlice";
import { setLoading } from "../../redux/Slice/loaderSlice";

const columns = [
  { id: "temp_id", label: "Template No", minWidth: 100, align: "start" },
  { id: "name", label: "Template Name", minWidth: 150, align: "start" },
  { id: "status", label: "Status", minWidth: 100, align: "center" },
  {
    id: "action",
    label: "Action",
    minWidth: 150,
    align: "center",
    actionType: [{ edit: true, view: true }],
  },
];

export const Temp = ({service_id}) => {

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modifiedRows, setModifiedRows] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const message = useSelector((state) => state.message);
  const { quoteService, totalCount } = useSelector((state) => state.quote);
  console.log("quoteService:",quoteService);

  const transformedQuotes = (quoteService) => quoteService.map((quote) => ({
    _id: quote._id,
    temp_id: quote.template_id,
    name: quote.templateName,
    status: quote.status ? true : false,
    action: "",
  }))

   useEffect(() => {
     if (Array.isArray(quoteService)) {
       const transformedLeads = transformedQuotes(quoteService);
       setModifiedRows(transformedLeads);
     }
   }, [quoteService]);
  

  // useEffect(() => {
  //   if (message?.message) {
  //     toast(message.message);
  //     dispatch(clearMessage());
  //   }
  // }, [message, dispatch]);

  useEffect(() => {
    // dispatch(setLoading(true));
    // dispatch(setLoading(true));
    const params = {
      page: page, 
      limit: rowsPerPage, 
      searchTerm: searchTerm
    }
    dispatch(getQuoteByServiceId({params, q_id: service_id }))
      // .then(() => {
      //   dispatch(setLoading(false));
      // })
      // .catch(() => {
      //   dispatch(setLoading(false));
      // });
      // .then(() => {
      //   dispatch(setLoading(false));
      // })
      // .catch(() => {
      //   dispatch(setLoading(false));
      // });
  }, [dispatch, page, rowsPerPage, searchTerm]);

  const handleStatusChange = (row) => {
    const updatedStatus = !row.status;
    const quoteId = row._id;

    dispatch(setLoading(true));
    dispatch(updateQuote( { q_id: quoteId, formData: { status: updatedStatus }})).unwrap()
     .then(() => {
    
      // Update the modifiedRows locally
      const updatedRows = modifiedRows.map((item) =>
        item._id === quoteId ? { ...item, status: updatedStatus } : item
      );
      setModifiedRows(updatedRows);
      })
      .catch((error) => {
        console.error("Failed to update status:", error);
        toast.error("Failed to update status. Please try again.");
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  }

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
    setPage(1);
  };

  const handleEdit = (row) => {
    if (row._id) {
      navigate(`edit-template/${row._id}`);
    } else {
      console.log("No lead ID found for this row", row);
    }
  };

  const handleView = (row) => {
    if(row._id) {
      navigate(`view-template/${row._id}`);
    } else {
      console.log("No Quote ID found for this row", row);
    }
  }

  return (
    <div >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{my: 2 }}>
          Templates 
          <Typography component="span">({totalCount})</Typography>
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}>
          <TextField placeholder="Search by Name" value={searchTerm} onChange={handleSearch} fullWidth/>

          <Link to="add-template" state={{service_id: service_id}}>
          <Button
            variant="contained"
            color="success"
            sx={{ ml: 2, px: 3 ,
              "&:hover": { backgroundColor: "#2FB354" },}}
          >
            Add
          </Button>
          </Link>
        </Box>
      </Box>

      <CustomTable
        columns={columns}
        rows={modifiedRows}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalCount={totalCount}
        handleEdit={handleEdit}
        handleView={handleView}
        handleStatusChange={handleStatusChange}
      />
    </div>
  );
};

